import React from "react";
import "./TextLoading.scss"
function TextLoading() {
  return (
    <div>
      <div className="typing typing-1"></div>
      <div className="typing typing-2"></div>
      <div className="typing typing-3"></div>
    </div>
  );
}

export default TextLoading;
